module.exports = __webpack_public_path__ + "static/img/title.422d60d.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/title.png
// module id = 4m86
// module chunks = 1